<template>
    <div class="single-filter date-filter">
        <v-date-picker color="blue"
                       ref="datePicker"
                       v-model="value"
                       @input="input"
                       mode="date"
                       :isDark="$store.state.theme.darkMode"
                       :masks="{
                       input:[dateFormat],
                       inputDateTime:[dateFormat+' h:mm A'],
                       inputDateTime24hr:[dateFormat+' HH:mm'],
                       inputTime:['h:mm A'],
                       inputTime24hr:['HH:mm']
                       }"
                       :popover="{visibility: 'click', placement: 'bottom-start'}">
            <template v-slot="{ inputValue, inputEvents }">
                <button class="btn btn-filter"
                        :class="{'applied': isApply}"
                        :id="filterId"
                        data-toggle="dropdown"
                        v-on="inputEvents"
                        @click="openPicker"
                        aria-haspopup="true" aria-expanded="false">
                    {{ inputValue && isApply ? inputValue : (value ? $t('today') : label) }}
                    <span class="clear-icon" v-if="isApply" @click="clear($event)">
                        <app-icon :name="'x'"/>
                    </span>
                </button>
            </template>
        </v-date-picker>
    </div>
</template>

<script>
import {FilterMixin} from './mixins/FilterMixin';
import CoreLibrary from "../../helpers/CoreLibrary";
import moment from 'moment/moment'

export default {
    name: "DateFilter",
    extends: CoreLibrary,
    mixins: [FilterMixin],
    props: {
        label: {
            type: String,
            default: function () {
                return this.$t('date')
            }
        },
        initialValue: {}
    },
    data() {
        return {
            isApply: !!this.initialValue,
            value: this.initialValue ? new Date(this.initialValue) : null,
        }
    },
    mounted() {
        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            this.isApply = false;
            this.value = null;
        });

        // Listen for other date pickers opening
        this.$hub.$on('date-filter-opened', (openedFilterId) => {
            if (this.filterId !== openedFilterId) {
                if (this.$refs.datePicker && this.$refs.datePicker.hidePopover) {
                    this.$refs.datePicker.hidePopover();
                }
            }
        });
    },
    methods: {
        openPicker() {
            this.$hub.$emit('date-filter-opened', this.filterId);
        },
        clear(e) {
            e.preventDefault(); // Changed from stopPropagation which might prevent specific handlers
            e.stopPropagation();
            this.isApply = false;
            this.value = null;
            this.sendValue(this.value);
            // Also close the popover when cleared, purely for UX
            if (this.$refs.datePicker && this.$refs.datePicker.hidePopover) {
                this.$refs.datePicker.hidePopover();
            }
        },
        input(value) {
            if (value) {
                this.isApply = true;
                this.sendValue(value);
            } else {
                this.isApply = false;
                this.value = null;
                this.sendValue(null);
            }
        },
        sendValue(value) {
            if (value) {
                this.returnValue(moment(value).format('YYYY-MM-DD').toString());
            } else {
                this.returnValue('');
            }
        }
    }
}
</script>

